/* eslint-disable no-unused-vars */
import React from 'react';
import { Checkbox, ParagraphWithTooltip } from 'components';
import { CheckTreeExportModalManageCampaigns } from 'assets/icons';
import * as S from './ExportTableModal.styled';

export const ColumnsSection = ({
  campaignSettings,
  isAllCampaignSelected,
  onHandleCampaign,
  onHandleCampaignAll,
}) => {
  return (
    <S.SectionContainer>
      <S.SectionBox>
        <Checkbox
          label='Campaign settings'
          name='Campaign settings'
          isChecked={isAllCampaignSelected && campaignSettings.some((el) => el.isSelected)}
          id='Campaign settings'
          isOpenGroup={isAllCampaignSelected && campaignSettings.some((el) => !el.isSelected)}
          onChange={onHandleCampaignAll}
          style={{ marginLeft: '24px', marginBottom: '12px' }}
        />
        {campaignSettings?.map(({ fieldName, title, isSelected, isDisabled = false }, index) => (
          <S.RowElement key={index}>
            <CheckTreeExportModalManageCampaigns />
            <Checkbox
              name={fieldName}
              isChecked={isSelected}
              isDisabled={isDisabled}
              id={fieldName}
              onChange={() => onHandleCampaign(fieldName)}
            />
            <S.ParagraphBox>
              <ParagraphWithTooltip text={title} />
            </S.ParagraphBox>
          </S.RowElement>
        ))}
      </S.SectionBox>
    </S.SectionContainer>
  );
};
